export const lastBuild = '2026-10-19T13:23:38.404Z';
